(() => {
  if (customElements.get('marame-account')) return;
  customElements.define('marame-account', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-marame-account-open]');
        if (!trigger || !this.isPlainClick(event)) return;
        if (this.open('account', trigger)) event.preventDefault();
      }, options);
      this.querySelector('[data-account-close]')?.addEventListener('click', () => this.close(), options);
      this.querySelector('[data-account-wishlist-link]')?.addEventListener('click', (event) => {
        if (!this.isPlainClick(event)) return;
        if (this.open('wishlist', event.currentTarget)) event.preventDefault();
      }, options);
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
      this.dialog.addEventListener('close', () => this.afterClose(), options);
      this.dialog.addEventListener('pointerdown', (event) => { this.pointerOutside = this.isOutside(event); }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.pointerOutside && this.isOutside(event)) this.close();
        this.pointerOutside = false;
      }, options);
    }
    isPlainClick(event) {
      return !event.defaultPrevented && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && !(event.button > 0);
    }
    isOutside(event) {
      if (event.target !== this.dialog) return false;
      const r = this.dialog.getBoundingClientRect();
      return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
    }
    open(mode, trigger) {
      if (typeof this.dialog?.showModal !== 'function') return false;
      const otherDialog = document.querySelector('dialog[open]');
      if (otherDialog && otherDialog !== this.dialog) return false;
      const wishlist = mode === 'wishlist' && this.dataset.signedIn !== 'true';
      const signIn = this.querySelector('.marame-account-primary');
      const signInUrl = wishlist ? signIn?.dataset.accountWishlistSignIn : signIn?.dataset.accountStandardSignIn;
      if (signInUrl && signIn.getAttribute('href') !== signInUrl) signIn.setAttribute('href', signInUrl);
      const signInNote = this.querySelector('[data-account-wishlist-note]');
      if (signInNote) signInNote.hidden = !wishlist;
      this.querySelector('[data-account-standard]').hidden = wishlist;
      this.querySelector('[data-account-wishlist]').hidden = !wishlist;
      this.dialog.setAttribute('aria-labelledby', wishlist ? 'MarameWishlistTitle' : 'MarameAccountTitle');
      clearTimeout(this.closeTimer);
      this.closeGeneration = (this.closeGeneration || 0) + 1;
      delete this.dialog.dataset.closing;
      if (!this.dialog.open) {
        try { this.dialog.showModal(); } catch (_) { return false; }
        this.trigger = trigger;
      }
      document.body.classList.add('marame-account-open');
      (this.querySelector('.marame-account-primary') || this.querySelector('[data-account-close]'))?.focus({ preventScroll:true });
      return true;
    }
    close() {
      if (!this.dialog.open || this.dialog.dataset.closing === 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { this.dialog.close(); return; }
      this.dialog.dataset.closing = 'true';
      const generation = this.closeGeneration;
      this.closeTimer = setTimeout(() => {
        if (this.isConnected && generation === this.closeGeneration && this.dialog.open) this.dialog.close();
      }, 220);
    }
    afterClose() {
      if (this.dialog.open) return;
      clearTimeout(this.closeTimer);
      delete this.dialog.dataset.closing;
      document.body.classList.remove('marame-account-open');
      if (document.querySelector('dialog[open]')) return;
      if (this.trigger?.isConnected && !this.trigger.closest('[inert]') && this.trigger.getClientRects().length) this.trigger.focus({ preventScroll:true });
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.closeGeneration = (this.closeGeneration || 0) + 1;
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('marame-account-open');
    }
  });
})();
